import { Column } from '@/features/ui/table/model';

export const BASE_COLUMNS: readonly Column[] = [
  { name: 'path', label: 'Standort', width: 150 },
  { name: 'spot', label: 'Gerät' },
  { name: 'category', width: 120 },
  { name: 'date', align: 'right' },
];
